import * as constants from '../constants';
import { updateFileDescription } from '../api';

const initialState = {};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.updateFileDescription.success: {
            return action.payload;
        }

        case constants.updateFileDescription.try: {
            return initialState;
        }

        case constants.updateFileDescription.error: {
            return initialState;
        }

        default:
            return state;
    }
}